<template>
  <!-- Spremeni vsa polja in gumbe v vue model in v-on:click 
  Glede na-->
  <app-hladilnik v-if="selected == 1" @applianceFormClicked="onApplianceFormClickedParent" />
  <app-washer v-if="selected == 2" @applianceFormClicked="onApplianceFormClickedParent" />
  <app-freezer v-if="selected == 3" @applianceFormClicked="onApplianceFormClickedParent" />
  <app-dish-washer v-if="selected == 4" @applianceFormClicked="onApplianceFormClickedParent" />
  <app-dryer v-if="selected == 5" @applianceFormClicked="onApplianceFormClickedParent" />
  <app-boiler v-if="selected == 6" @applianceFormClicked="onApplianceFormClickedParent" />
  <app-computer v-if="selected == 7" @applianceFormClicked="onApplianceFormClickedParent" />
  <app-printer v-if="selected == 8" @applianceFormClicked="onApplianceFormClickedParent" />
  <app-televizija v-if="selected == 9" @applianceFormClicked="onApplianceFormClickedParent" />
  <app-oven v-if="selected == 10" @applianceFormClicked="onApplianceFormClickedParent" />
  <app-air-con v-if="selected == 11" @applianceFormClicked="onApplianceFormClickedParent" />
</template>

<script>
import AppAirCon from './app_forms/AppAirCon.vue';
import AppBoiler from './app_forms/AppBoiler.vue';
import AppComputer from './app_forms/AppComputer.vue';
import AppDryer from './app_forms/AppDryer.vue';
import AppFreezer from './app_forms/AppFreezer.vue';
import AppHladilnik from './app_forms/AppHladilnik.vue';
import AppWasher from './app_forms/AppWasher.vue';
import AppDishWasher from './app_forms/AppDishWasher.vue';
import AppPrinter from './app_forms/AppPrinter.vue';
import AppTelevizija from './app_forms/AppTelevizija.vue';
import AppOven from './app_forms/AppOven.vue';

export default {
  props: {
    selected: Number,
  },
  components: {
    AppHladilnik,
    AppFreezer,
    AppDryer,
    AppBoiler,
    AppComputer,
    AppAirCon,
    AppWasher,
    AppDishWasher,
    AppTelevizija,
    AppPrinter,
    AppOven,
  },
  methods: {
    onApplianceFormClickedParent(x) {
      console.log('From New');
      this.$emit('applianceForm', x);
    },
  },
};
</script>

<style>
</style>